import React from "react";
import { connect } from "react-redux";
import { get, find } from "lodash";
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardBody,
  MDBCardHeader
} from "mdbreact";
// import Select from "~/components/common/atoms/Select";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
import PatientInfomationLess from "~/components/desktop/molecules/PatientInfomationLess";
import TagName from "~/components/common/atoms/TagName";
import styles from "./style.module.scss";
import cx from "classnames";
import PKHBtn from "~/components/common/atoms/Button";
import { routerByPartnerId } from "~/utils/func";

import { partnerInfo } from "~/configs/partnerDetails";
const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

class InstructionBHYT extends React.Component {
  handleContinueAction = () => {
    const { partnerId, history } = this.props;
    const route = routerByPartnerId("/xac-nhan-thong-tin", partnerId);
    history.push(route);
  };

  handleGoBack = () => {
    let route = "";
    route = "/chon-ho-so";
    this.props.history.push({
      pathname: route
    });
  };

  render() {
    return (
      <div className={styles.wapper_page_desktop}>
        <MDBContainer>
          <MDBRow className="row_mobile">
            <MDBCol md="12" lg="3">
              <PatientInfomationLess />
            </MDBCol>
            <MDBCol md="12" lg="9">
              <MDBCard className={cx(styles.panels, styles.panel_mobile)}>
                <MDBCardHeader className={styles.panels_header}>
                  <TagName
                    element="h2"
                    className={[
                      "title_component",
                      "title_choose_date",
                      "space_between",
                      "title_header_mobile"
                    ]}
                  >
                    <span>Quy định dành cho bệnh nhân khám Bảo hiểm</span>
                  </TagName>
                </MDBCardHeader>
                <MDBCardBody className={styles.card_body}>
                  <div className={styles.list_type}>
                    <span>
                      Vui lòng xác nhận có các loại giấy tờ sau khi đến khám
                      bệnh:
                    </span>
                    <div className={styles.instruction}>
                      - Thẻ Bảo hiểm Y tế còn hạn.
                    </div>
                  </div>
                </MDBCardBody>
                <div className={styles.next_prev}>
                  <PKHBtn backdesktop="backdesktop" onClick={this.handleGoBack}>
                    Quay lại
                  </PKHBtn>
                  <PKHBtn
                    onClick={this.handleContinueAction}
                    buttonArrow="buttonArrow"
                    nextStep
                    create="create"
                  >
                    Tiếp tục
                  </PKHBtn>
                </div>
              </MDBCard>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    partnerId: state.totalData.partnerId,
    partnerName: state.hospital.selectedHospital.name
  };
};

const InstructionBHYTHelmet = withTitle({
  component: InstructionBHYT,
  title: `${hospitalName.value} | Hướng dẫn BHYT`
});

export default connect(mapStateToProps, {})(InstructionBHYTHelmet);
